import script from "./TopHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TopHeader.vue?vue&type=script&setup=true&lang=js"

import "./TopHeader.vue?vue&type=style&index=0&id=961af19a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-961af19a"]])

export default __exports__